import { Form, Offcanvas, Spinner } from "react-bootstrap";

const ReviewFormDataEntry = ({
  signatureStudySubjectFormReviewHistoryDataEntry,
  signButtonLoader,
  Show,
  Hide,
  Title,
  setUserId,
  userId,
  setPassword,
  password,
}) => {
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group style={{ textAlign: "justify", fontSize: 13 }}>
            <p className="br3 bg-primary-subtle p-2">
              You are required to provide a signature for this activity in order
              to fully complete it. This records that you are signing off theat
              you have taken, and completed this online review activity. This
              will resilt in the completion record being recorded in your review
              history.
            </p>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="fw-bold mb-1">
              UserId{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setUserId(e.target.value)}
              value={userId}
              className="br3"
              placeholder="UserId"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label className="fw-bold mb-1">
              Password{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              className="br3"
              placeholder="Password"
              type="password"
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-gold border-top shadow-sm text-end">
          <button
            disabled={!userId || !password || signButtonLoader}
            className="updateProfile"
            onClick={(e) => signatureStudySubjectFormReviewHistoryDataEntry(e)}
          >
          {signButtonLoader ?
            <div className="hstack gap-2">
              <Spinner size="sm"/> Signing...
            </div>
          : "Sign Now"
          }
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default ReviewFormDataEntry;
